var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtn)?_c('span',{staticClass:"text-primary"},[_c('i',{staticClass:"fa fa-info-circle fa-lg icon-button mr-1",attrs:{"title":"Detalhar Requisição"},on:{"click":function($event){$event.stopPropagation();return _vm.detalharRequisicao()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }